/**
 * Filters linked-order confirmation rows to later-DOS siblings only.
 * @module filterLaterDosSiblingClubbedRows
 */
import { SingleOrderClubbedData } from "../../../../../components/expandableTableForOrderAuth/types";
import { isLaterDateOfService } from "./isLaterDateOfService";

/**
 * Keeps only sibling rows whose DOS is strictly after the parent DOS.
 *
 * @param clubbedRows - Clubbed sibling rows for the confirmation dialog
 * @param parentDateOfService - Parent order date of service
 * @returns Rows with later DOS than the parent
 */
export const filterLaterDosSiblingClubbedRows = (
  clubbedRows: SingleOrderClubbedData[],
  parentDateOfService?: string,
): SingleOrderClubbedData[] => {
  if (!parentDateOfService) {
    return [];
  }

  return clubbedRows.filter((row) =>
    isLaterDateOfService(
      parentDateOfService,
      row.order_data?.payload?.date_of_service,
    ),
  );
};
